

// Store an item in local storage
export const setLocalStorageItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

// Retrieve an item from local storage
export const getLocalStorageItem = (key) => {

  // console.log("Retrieving item from local storage with key:", key);
  const item = localStorage.getItem(key);
  // console.log("Retrieved item from local storage:", item)
  // Parse the item from JSON format

  if (item) {
    try {
      return JSON.parse(item);
    } catch (error) {
      console.error("Error parsing local storage item:", error);
      return null;
    }
  }
  return null;
};


// Remove an item from local storage
export const removeLocalStorageItem = (key) => {
  localStorage.removeItem(key);
};